import {
  DismissAfterAccountAge,
  useDismissableModule,
} from "@mirage/service-onboarding/useDismissableModule";
import { useDashUserAttributes } from "@mirage/shared/eligibility/hooks/useDashUserAttributes";
import { isDashStandaloneWeb } from "@mirage/shared/utils/environment-detection";
import { useMemo } from "react";

const DISMISSED_BRIDGE_USER_SUGGESTIONS = "dismissedBridgeUserSuggestions";

export const useShowBridgeUserSuggestions = () => {
  const { userAttributes } = useDashUserAttributes();
  const dismissBehavior = useMemo(() => new DismissAfterAccountAge("7d"), []);
  // For future version, there will be some conditions added to the dismiss suggestion based on the user's behavior.
  // For now, we don't have manual dismiss yet and dismiss after 7 days.
  const { dismissed } = useDismissableModule(
    DISMISSED_BRIDGE_USER_SUGGESTIONS,
    dismissBehavior,
  );

  const isWebBridgeUser =
    isDashStandaloneWeb() && !!userAttributes?.hasDashInFss;

  return isWebBridgeUser && !dismissed;
};
